function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"));
var _ref2 = /*#__PURE__*/React.createElement("title", null, "idea");
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 24,
  width: 10,
  height: 2
});
var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 13,
  y: 28,
  width: 6,
  height: 2
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16,2A10,10,0,0,0,6,12a9.19,9.19,0,0,0,3.46,7.62c1,.93,1.54,1.46,1.54,2.38h2c0-1.84-1.11-2.87-2.19-3.86A7.2,7.2,0,0,1,8,12a8,8,0,0,1,16,0,7.2,7.2,0,0,1-2.82,6.14c-1.07,1-2.18,2-2.18,3.86h2c0-.92.53-1.45,1.54-2.39A9.18,9.18,0,0,0,26,12,10,10,0,0,0,16,2Z",
  transform: "translate(0 0)"
});
var _ref6 = /*#__PURE__*/React.createElement("rect", {
  id: "_Transparent_Rectangle_",
  "data-name": "<Transparent Rectangle>",
  className: "cls-1",
  width: 32,
  height: 32
});
const SvgIdea = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "icon",
  viewBox: "0 0 32 32",
  ref: svgRef
}, props), _ref, title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIdea, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/idea.067adb46.svg";
export { ForwardRef as ReactComponent };